export default {_name:'text.status',module:'Field',view:'Element/Text/Status',options:{xs:'auto'},mobileOptions:{ms:'auto'}}